import React, { useState } from 'react';
import { Grid, Paper, Typography, IconButton, Button } from '@mui/material';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import MultiSelectNew from '../BaselineEmission/MultSelectNew';

interface FilterSectionProps {
  locationOptions: Array<{ id: number; label: string; value: string }>;
  selectedLocations: number[];
  onLocationChange: (selectedOptions: number[]) => void;
  onSearch: () => void;
}

const FilterSection: React.FC<FilterSectionProps> = ({
  locationOptions,
  selectedLocations,
  onLocationChange,
  onSearch,
}) => {
  const [showFilters, setShowFilters] = useState(false);

  const toggleFilters = () => {
    setShowFilters(!showFilters);
  };

  return (
    <Grid item xs={12} sx={{ width: '100%', maxWidth: '100%', px: 0 }}>
      <Paper variant="outlined" sx={{
        padding: 1.5,
        ml: 0,
        mt: 0.5,
        mb: 0.5,
        mr: 0,
        width: '100%',
        maxWidth: '100%',
        overflow: 'hidden',
        boxSizing: 'border-box',
      }}>
        <button
          type="button"
          style={{
            display: 'flex',
            alignItems: 'center',
            cursor: 'pointer',
            background: 'none',
            border: 'none',
            padding: 0,
            width: '100%',
          }}
          data-testid="toggleFiltersButton"
          onClick={toggleFilters}
          aria-pressed={showFilters}
        >
          <Typography variant="body1" sx={{ fontWeight: 600, fontSize: '18px', color: '#27272E', marginLeft: '4px' }}>
            Filters
          </Typography>
          <div style={{ marginLeft: 'auto' }}>
            <IconButton>{showFilters ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}</IconButton>
          </div>
        </button>
        {showFilters && (
          <Grid container alignItems="center" justifyContent="space-between" sx={{ width: '100%', maxWidth: '100%', mt: 1 }}>
            <Grid item xs={5}>
              <Typography variant="body1" sx={{ mr: 8 }}>
                Locations
              </Typography>
              <MultiSelectNew
                dataTestId="locationSelect"
                options={locationOptions}
                onSelectionChange={onLocationChange}
                selectedOptions={selectedLocations}
              />
            </Grid>
            {selectedLocations.length > 0 && (
              <Grid item xs={6} container justifyContent="flex-end">
                <Button type="submit" variant="contained" data-testid="btnSearch" onClick={onSearch}>
                  Search
                </Button>
              </Grid>
            )}
          </Grid>
        )}
      </Paper>
    </Grid>
  );
};

export default FilterSection;